import gql from 'graphql-tag'

export const PRODUCT_AVAILABILITY_FRAGMENT = gql`
  fragment productAvailabilityFragment on ProductAvailability {
    key
    status
    countMall
    countOutlets
    countSupplier
    countExternal
    countShowrooms
    isAvailable
    showrooms {
      id
      count
    }
  }
`
